import { render, staticRenderFns } from "./circularList.vue?vue&type=template&id=15bf13dd&scoped=true&"
import script from "./circularList.vue?vue&type=script&lang=js&"
export * from "./circularList.vue?vue&type=script&lang=js&"
import style0 from "./circularList.vue?vue&type=style&index=0&id=15bf13dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf13dd",
  null
  
)

export default component.exports